module.exports = __webpack_public_path__ + "img/cash_100.70df42f0.svg";